import React from 'react';
import BulkEntry from 'portfolio/components/bulk-entry';
import Activities from 'shared/portfolio/components/activities/activities';
import CommunityService from 'shared/portfolio/components/community-service/community-service';
import WorkExperiences from 'shared/portfolio/components/work-experiences/work-experiences';
import TestScores from 'shared/portfolio/components/test-scores/test-scores';
import HonorAwards from 'shared/portfolio/components/honor-awards/honor-awards';
import Multimedia from 'shared/portfolio/components/multimedia/multimedia-items';
import CollegeSuccess from 'shared/college-success/containers';

const HighSchoolPortfolioItems = () => (
  <>
    <BulkEntry />
    <Activities />
    <CommunityService />
    <WorkExperiences />
    <TestScores />
    <HonorAwards />
    <CollegeSuccess title="College Readiness" subtitle="Explore Ways to Prepare For College" />
    <Multimedia />
  </>
);

export default HighSchoolPortfolioItems;
